import React from 'react';
import InboxLayer from '../../../components/nav/myInfoLayer/inboxLayer'

const Memo = () => {
    return (
        <InboxLayer />
    );
}

export default Memo;